import { useFeatureValue } from '@shared/core/featureFlags';
import { useEventTypeConfig } from '@shared/utils/eventType';

export const useEnableChecklist = () => {
  const { config } = useEventTypeConfig();
  const featureFlagEnabled = useFeatureValue('enableChecklistInGiftBasketWidget');

  return config?.checklistInGiftBasketWidgetEnabled && featureFlagEnabled;
};
